<div class="planner-container">
    <div class="container-flex">
        @if (showCsat) {
            <app-feedback></app-feedback>
        }
        <div class="d-inline-flex justify-content-between">
            <div class="col-2"></div>
            <app-wizard
                class="planner-wizard mb-3 col-8"
                [stepTitles]="menuItemTitles"
                [activeStep]="currentPage"
                [disabled]="navigationDisabled"
                (changed)="navigateToPage($event)"
            ></app-wizard>
            <div class="col-2">
                @if (currentPage <= 2 && optimizationSettingsPlacementEnabled | async) {
                    <button
                        type="button"
                        class="btn btn-default d-flex align-items-center my-auto justify-content-center"
                        [ngClass]="{
                            'settings-btn': currentBreakpointValue >= BreakpointValue.LARGE,
                            'settings-btn-sm': currentBreakpointValue < BreakpointValue.LARGE}"
                        (click)="openSettingsModal()"
                    >
                        <div class="vismaicon icon-settings mx-1"></div>
                        @if (currentBreakpointValue >= BreakpointValue.LARGE) {
                            <span translate="BUTTON_SETTINGS"></span>
                        }
                    </button>
                }
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
    <div class="planner-navigation-buttons py-3">
        <div class="left-container">
            @if (currentPage !== 0) {
                <button
                    class="btn left"
                    [ngClass]="{ disabled: navigationDisabled }"
                    (click)="previousPage()"
                >
                    <span>
                        {{ 'BACK_TO' | translate }} <b>{{ menuItemTitles[currentPage - 1] | translate }}</b>
                    </span>
                </button>
            }
        </div>
        <div class="right-container">
            @if (rideSharingEnabledOnClientSide && (currentPage === 0 || currentPage === 1)) {
                <app-ride-sharing-bar
                    class="mr-2 py-0">
                    >
                </app-ride-sharing-bar>
            }
            @if (!saveAndResetButtons && !resetButtonOnly && !nextButtonHidden) {
                <button
                    class="btn btn-primary right my-auto"
                    [ngClass]="{ disabled: navigationDisabled || nextButtonDisabled || currentPage === totalPageCount - 1 }"
                    (click)="nextPage()"
                >
                    <span>
                        {{ 'NEXT_TO' | translate }} <b>{{ menuItemTitles[currentPage + 1] | translate }}</b>
                    </span>
                </button>
            }

            @if (saveAndResetButtons || resetButtonOnly) {
                <button
                    class="btn btn-default my-auto"
                    [ngClass]="{ disabled: !saveAndResetButtonsActive }"
                    (click)="resetClick()"
                >
                    <span translate="RESET" data-qa="qa-button-reset"></span>
                </button>
                @if (!resetButtonOnly) {
                    <button
                        class="btn btn-primary my-auto"
                        [ngClass]="{ disabled: !saveAndResetButtonsActive }"
                        (mousedown)="$event.preventDefault()"
                        (click)="saveClick()"
                    >
                        <span translate="SAVE" data-qa="qa-button-save"></span>
                    </button>
                }
            }
        </div>
    </div>
    <span class="visma-logo"></span>
</div>
